import { TILE } from '../config';
import type { Landmark } from '../types';

const T = (tx: number, ty: number) => ({ x: tx * TILE + TILE / 2, y: ty * TILE + TILE / 2 });

export const LANDMARKS: Landmark[] = [
  { name: 'Pier Head',          ...T(10, 26) },
  { name: 'Liver Building',     ...T(11, 24) },
  { name: 'Albert Dock',        ...T(12, 46) },
  { name: 'Anfield',            ...T(28, 7)  },
  { name: 'Sefton Park',        ...T(66, 50) },
  { name: 'Cavern Club',        ...T(34, 28) },
  { name: 'Lime Street',        ...T(40, 26) },
  { name: 'St Georges Hall',    ...T(42, 28) },
  { name: 'Toxteth',            ...T(30, 50) },
  { name: 'Bootle',             ...T(35, 6)  }
];

export function landmark(name: string): Landmark {
  const l = LANDMARKS.find(l => l.name === name);
  if (!l) throw new Error(`unknown landmark ${name}`);
  return l;
}
